import { array, intersect, partial, struct, union } from 'io-ts/Decoder';

import { Id as ClientId } from '../../../client/Id';
import { Id as OrganizationId } from '../../../organization/Id';

export const Request = union(
	intersect(
		struct({
			clientIds: array(ClientId),
		})
	)(
		partial({
			organizationIds: array(OrganizationId),
		})
	),
	struct({
		organizationIds: array(OrganizationId),
	})
);
